import React from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { currencyFormat } from "../utils";
import { Dropdown } from "primereact/dropdown";
import { handlePhonePaste } from "../utils";

import { PHONE_CODES } from "../constants";

const PaymentDialog = ({
  visible,
  onHide,
  paymentDetails,
  setPaymentDetails,
  onSubmit,
  amountBs,
}) => {
  return (
    <Dialog
      header="Realizar Pago"
      visible={visible}
      style={{ width: "50vw" }}
      onHide={onHide}
    >
      <div className="p-fluid">
        <h3 className="text-center">Total a pagar</h3>
        <p className="text-2xl font-bold text-center">{`${currencyFormat(
          amountBs
        )} Bs.`}</p>

        <p
          className="font-bold  text-center"
          style={{
            border: "2px solid black",
            borderRadius: "5px",
            padding: "10px",
          }}
        >
          <span className="p-ml-2">
            <i
              className="pi pi-info-circle"
              style={{ color: "#007ad9", fontSize: "25px" }}
            ></i>
          </span>
          <br></br>
          DEBES PAGAR EL MONTO EXACTO, DE LO CONTRARIO EL SISTEMA NO PODRÁ
          VALIDAR SU PAGO.
        </p>

        <div className="p-field">
          <p className="font-bold">Realizar el pago móvil a:</p>
          <div className="p-mb-2 flex">
            <div className="flex-auto">
              <p className="m-0">
                <strong>Número de Teléfono:</strong>{" "}
                <span>{"0412-3034004"}</span>
              </p>
            </div>
            <div className="w-3">
              <Button
                label="Copiar"
                icon="pi pi-copy"
                className="p-button-text"
                onClick={() => navigator.clipboard.writeText("0412-3034004")}
              />
            </div>
          </div>
          <div className="p-mb-2 flex ">
            <div className="flex-auto">
              <p className="m-0">
                <strong>RIF:</strong> <span>J-503151277</span>
              </p>
            </div>
            <div className="w-3">
              <Button
                label="Copiar"
                icon="pi pi-copy"
                className="p-button-text"
                onClick={() => navigator.clipboard.writeText("J-503151277")}
              />
            </div>
          </div>
          <div className="p-mb-3c flex">
            <div className="flex-auto">
              <p className="m-0">
                <strong>Banco:</strong> 0105 <span>Mercantil</span>
              </p>
            </div>
            <div className="w-3">
              <Button
                label="Copiar"
                icon="pi pi-copy"
                className="p-button-text"
                onClick={() => navigator.clipboard.writeText("0105")}
              />
            </div>
          </div>
          <Button
            label="Copiar datos"
            icon="pi pi-copy"
            className="p-button-text"
            onClick={() =>
              navigator.clipboard.writeText(
                `0105\n0412-3034004\nJ-503151277\n${amountBs}`
              )
            }
          />
        </div>
        <div className="p-field">
          <label htmlFor="phoneNumber">Número de Teléfono</label>

          <div className="field-with-select">
            <Dropdown
              id="phoneCode"
              name="phoneCode"
              options={PHONE_CODES}
              placeholder="Código"
              value={paymentDetails.phoneCode}
              onChange={(e) =>
                setPaymentDetails({
                  ...paymentDetails,
                  phoneCode: e.value,
                })
              }
            />

            <InputText
              id="phoneNumber"
              name="optionalPhoneNumber"
              inputMode="numeric"
              keyfilter="pint"
              maxLength={7}
              value={paymentDetails.phoneNumber}
              onChange={(e) => {
                setPaymentDetails({
                  ...paymentDetails,
                  phoneNumber: e.target.value,
                });
                // (e.target.value)
              }}
              onPaste={(e) => {
                const phoneNumber = handlePhonePaste(e);
                console.log(phoneNumber);
                setPaymentDetails({
                  ...paymentDetails,
                  phoneCode: phoneNumber["code"],
                  phoneNumber: phoneNumber["phoneNumber"],
                });
                //   handlePhonePaste(e, "optionalPhoneCode", "optionalPhoneNumber")
              }}
            />
          </div>
        </div>
        <div className="p-field">
          <label htmlFor="paymentDate">Fecha del Pago</label>
          <Calendar
            id="paymentDate"
            value={paymentDetails.paymentDate}
            onChange={(e) =>
              setPaymentDetails({ ...paymentDetails, paymentDate: e.value })
            }
          />
        </div>
        <div className="p-field">
          <label htmlFor="referenceLastDigits">
            Últimos 4 Dígitos de Referencia
          </label>
          <InputText
            id="referenceLastDigits"
            value={paymentDetails.referenceLastDigits}
            onChange={(e) =>
              setPaymentDetails({
                ...paymentDetails,
                referenceLastDigits: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="p-dialog-footer mt-4">
        <Button label="Confirmar" icon="pi pi-check" onClick={onSubmit} />
        <Button
          type="button"
          icon="pi pi-times"
          label="Cancelar"
          style={{ backgroundColor: "#999999", borderColor: "#999999" }}
          onClick={onHide}
        />
      </div>
    </Dialog>
  );
};

export default PaymentDialog;
